// extracted by mini-css-extract-plugin
module.exports = {"overlayMenu":"overlayMenu_overlayMenu__1SnbE"};